import React, { forwardRef, useEffect } from 'react'
import { Controller } from 'react-hook-form'
import ReactSelect, { components } from 'react-select'
import Selectstyles from './Selectstyles'

const Option = (props: any) => {
  return (
    <>
      <components.Option {...props}>{props.children}</components.Option>
    </>
  )
}

const SelectDropDown = forwardRef((props: any, reference: any) => {
  const {
    module,
    value,
    placeholder,
    formControl,
    formControlErr,
    options,
    formSetvalue,
    formClrearErr,
  } = props

  useEffect(() => {
    if (value && Object.keys(value).length > 0) {
      formSetvalue(module, value)
    }
  }, [value])

  const customStyles = Selectstyles(formControlErr?.[module])

  return (
    <>
      <Controller
        name={module}
        control={formControl}
        render={({ field }) => (
          <ReactSelect
            {...field}
            styles={customStyles}
            className={`w-100 ${formControlErr?.[module] ? 'error-input' : ''}`}
            options={[...options]}
            placeholder={placeholder}
            classNamePrefix='crm_select'
            ref={reference}
            components={{ Option }}
          />
        )}
      />
      <small className='text-danger'>
        {formControlErr?.[module]?.value?.message}
      </small>
    </>
  )
})

export default SelectDropDown
